import React from 'react';
import { Box, Heading, Divider, Container } from '@chakra-ui/react';
import SocialMedia from './SocialMedia';
import Contact from './Contact';

export default function Encuentranos() {
  return (
    <Box bg="bg.default" flex="1" pb={{ base: 12, md: 24 }}>
      <Container maxW="container.xl" pt={{ base: 8, md: 12 }}>
        <Heading textAlign="center" color="text.default" mb={2}>
          Encuéntranos
        </Heading>
      </Container>
      <Container maxW="container.md">
        <Divider my={4} borderColor="border.default" />
      </Container>
      
      <SocialMedia />
      
      <Container maxW="container.md">
        <Divider my={4} borderColor="border.default" />
      </Container>
      
      <Contact />
    </Box>
  );
}
